import React from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.inspections_attachments';
const SEG_OPTIONS = [
    { label: translate('brushaway.result_pass', { namespace }), value: 'pass', onClass: 'is-on--pass' },
    { label: translate('brushaway.result_fail', { namespace }), value: 'fail', onClass: 'is-on--fail' },
    { label: translate('brushaway.result_none', { namespace }), value: '', onClass: '' }
];
export function SegmentedControl({ value, onChange }) {
    const current = value !== null && value !== void 0 ? value : '';
    return (React.createElement("div", { className: "seg", role: "radiogroup", "aria-label": translate('brushaway.result_label', { namespace }) }, SEG_OPTIONS.map((opt) => (React.createElement("button", { key: opt.value, type: "button", role: "radio", "aria-checked": current === opt.value, className: current === opt.value ? opt.onClass : '', onClick: () => onChange((opt.value || null)) }, opt.label)))));
}
